import api from "../../Api/apiAxios";

export async function verificarClientesSemCodigoSisdm(periodo) {
    const resp = await api.get(`/Sisdm/clientes-sem-codigo?periodo=${periodo}`);
    return Array.isArray(resp.data) ? resp.data : [];
}

export async function baixarClientesSemCodigoSisdm(periodo) {
    const resp = await api.get(`/Sisdm/clientes-sem-codigo/exportar?periodo=${periodo}`, {
        responseType: 'blob'
    });

    const blob = new Blob([resp.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `clientes_sem_codigo_sisdm_${periodo}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
}
